export class CreditCardTransactionDetail {
  public constructor() {
    this.Succeeded = false;
    this.TransactionId = '';
    this.Id = 0;
    this.TranDate = new Date();
    this.CardType = '';
    this.Amount = 0;
    this.PurchaseDescr = '';
    this.ProfileId = 0;
    this.CardNumLast4Digits = '';
    this.ProcessMethod = '';
    this.CcGatewayId = '';
    this.AuthorizationCode = '';
    this.RevenueItemDescription = '';
    this.InvoiceNum = 0;
    this.NameOnCard = '';
    this.InvoiceDate = new Date();
    this.DueDate = new Date();
    this.PaymentDate = new Date();
  }

  public Succeeded: boolean;
  public TransactionId: string;
  public Id: number;
  public TranDate: Date;
  public CardType: string;
  public Amount: number;
  public PurchaseDescr: string;
  public ProfileId: number;
  public CardNumLast4Digits: string;
  public ProcessMethod: string;
  public CcGatewayId: string;
  public AuthorizationCode: string;
  public RevenueItemDescription: string;
  public InvoiceNum: number;
  public NameOnCard: string;
  public InvoiceDate: Date;
  public DueDate: Date;
  public PaymentDate: Date;
}
